import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { http } from "../../../../../services/HttpService";

export const useSetPfiConfigs = (options = {}) => {
  const res = useMutation(
    (dto) => http.put(HTTP_ENDPOINTS.patientFiIntegration.setPfiConfigs(), dto),
    {
      ...options,
    },
  );
  return res;
};
